var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-section',{attrs:{"id":"violation_form","headline":this.$t('form.violation.headline')}},[_c('textfield',{attrs:{"id":"agreement_description","label":_vm.$t('form.violation.amount.label'),"placeholder":_vm.$t('form.violation.amount.placeholder'),"isRequired":""},on:{"focus":function($event){return _vm.scrollTo('#violation_contract')}},model:{value:(_vm.violation.amount),callback:function ($$v) {_vm.$set(_vm.violation, "amount", $$v)},expression:"violation.amount"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/hemmelig/components/form/Violation.vue?vue&type=template&id=bfcf40e2&
// module id = null
// module chunks = 